import { Component } from '@angular/core';
import { PropertyManagementService } from '@modules/ota-v2/hotel-ota/services/property-management/property-management.service';
import { filter, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { OTA_WARNING } from '@modules/ota-v2/hotel-ota/enum/warning-ota';
import { BrowseAccount } from '@shared/enum/browse-account.enum';

@Component({
  selector: 'app-general-warning',
  templateUrl: './general-warning.component.html',
  styleUrls: ['./general-warning.component.scss']
})
export class GeneralWarningComponent {
  onDestroy$: Subject<void> = new Subject();
  warnings: string[] = [];
  propertyId: string = '';
  propertyName: string = '';
  OTA_WARNING = OTA_WARNING;
  expired_date: string = '';
  role: string = '';
  BrowseAccount = BrowseAccount;
  isAdminView: boolean = false;
  
  constructor(
    private propertyManagementService: PropertyManagementService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.propertyManagementService
      .getPropertySelected()
      .pipe(
        takeUntil(this.onDestroy$),
        filter((property: any) => !!property))
      .subscribe((property: any) => {
        this.expired_date = property.expired_date;
        this.role = property.role;
        this.warnings = property.property_warnings || [];
    });
      this.route.queryParams.subscribe((params: Params) => {
      this.propertyId = params['property_id'];
      this.propertyName = params['property_name'];
    });
    this.isAdminView = localStorage.getItem(BrowseAccount.PERMISSION) == BrowseAccount.ADMIN;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  navigateContactPage() {
    this.router.navigate([`/ota-v2/hotel-ota/hotel-management/${encodeURIComponent(this.propertyName)}/settings/contract-agreement`], {
      queryParams: {
        property_id: this.propertyId,
        property_name: encodeURIComponent(this.propertyName),
      },
    });   
  }
}
